import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useMemo } from "react";
import "./App.css";
import { TrackingProvider } from "./analytics/TrackingProvider.tsx";
import { Router } from "./Router";
import { LoadingScreenProvider } from "./screens/LoadingScreen";

declare global {
  interface Window {
    __track: (event: string, properties?: Record<string, unknown>) => void;
  }
}

export const App = () => {
  const queryClient = useMemo(() => new QueryClient(), []);

  return (
    <QueryClientProvider client={queryClient}>
      <LoadingScreenProvider>
        <TrackingProvider
          track={(event, properties) => {
            if (window.__track) {
              window.__track(event, properties);
              document.dispatchEvent(
                new CustomEvent(`PICK3:${event}`, { detail: properties }),
              );
            }

            if (import.meta.env.MODE === "development") {
              console.debug("track", event, properties);
            }
          }}
        >
          <Router />
        </TrackingProvider>
      </LoadingScreenProvider>
    </QueryClientProvider>
  );
};
